import zones from '../zones.json';
import roads from '../roads.json';
import styles from '../styles';

// Big zones & roads map
export const riskAssessmentZonesBig = {
	key: 'risk-assessment-zones-big',
	name: 'Zones',
	type: 'vector',
	options: {
		features: zones.features,
		style: styles.byKey.riskAssessmentZonesDeformationBig.data.definition,
		fidColumnName: 'gid',
		hoverable: true,
		hovered: {
			style: 'default',
		},
		selectable: true,
		selected: {
			riskAssessmentZones: {},
		},
	},
};

export const riskAssessmentRoadsBig = {
	key: 'risk-assessment-roads-big',
	name: 'Roads',
	type: 'vector',
	options: {
		features: roads.features,
		style: styles.byKey.riskAssessmentRoadsVelAvgBig.data.definition,
		fidColumnName: 'gid',
		selectable: true,
		hoverable: true,
		selected: {
			riskAssessmentRoads: {},
		},
		hovered: {
			style: {
				outlineColor: '#00ffff',
			},
		},
	},
};

// Small zones & roads map
export const riskAssessmentZonesSmall = {
	key: 'risk-assessment-zones-small',
	type: 'vector',
	options: {
		renderingTechnique: 'canvas',
		features: zones.features,
		style: styles.byKey.riskAssessmentZonesDeformationSmall.data.definition,
		fidColumnName: 'gid',
		selected: {
			riskAssessmentZones: {},
		},
	},
};

export const riskAssessmentRoadsSmall = {
	key: 'risk-assessment-roads-small',
	type: 'vector',
	options: {
		renderingTechnique: 'canvas',
		features: roads.features,
		style: styles.byKey.riskAssessmentRoadsVelAvgSmall.data.definition,
		fidColumnName: 'gid',
		selected: {
			riskAssessmentRoads: {},
		},
	},
};

// Big interferometry map
export const interferometryZonesBig = {
	key: 'interferometry-zones-big',
	type: 'vector',
	options: {
		renderingTechnique: 'canvas',
		features: zones.features,
		style: styles.byKey.interferometryZonesBig.data.definition,
		fidColumnName: 'gid',
		selected: {
			riskAssessmentZones: {},
		},
	},
};

export const interferometryRoadsBig = {
	key: 'interferometry-roads-big',
	name: 'Roads',
	type: 'vector',
	options: {
		renderingTechnique: 'canvas',
		features: roads.features,
		style: styles.byKey.riskAssessmentRoadsVelAvgBig.data.definition,
		fidColumnName: 'gid',
		selected: {
			riskAssessmentRoads: {},
		},
	},
};

export const interferometryPointsBig = {
	key: 'interferometry-points-big',
	type: 'vector',
	options: {
		renderAs: [
			{
				options: {
					renderingTechnique: 'canvas',
					pointAsMarker: false,
					style:
						styles.byKey.interferometryPointsVelAvgBigAsPoints.data.definition,
				},
				boxRangeRange: [1500, null],
			},
			{
				boxRangeRange: [null, 1500],
			},
		],
		pointAsMarker: true,
		features: [],
		hoverable: true,
		hovered: {
			style: 'default',
		},
		selectable: true,
		selected: {
			interferometry: {},
		},
		style: styles.byKey.interferometryPointsVelAvgBig.data.definition,
		fidColumnName: 'id',
	},
};

// Small interferometry map
export const interferometryZonesSmall = {
	key: 'interferometry-zones-small',
	type: 'vector',
	options: {
		renderingTechnique: 'canvas',
		features: zones.features,
		style: styles.byKey.interferometryZonesSmall.data.definition,
		fidColumnName: 'gid',
		selected: {
			riskAssessmentZones: {},
		},
	},
};

export const interferometryRoadsSmall = {
	key: 'interferometry-roads-small',
	name: 'Roads',
	type: 'vector',
	options: {
		renderingTechnique: 'canvas',
		features: roads.features,
		style: styles.byKey.riskAssessmentRoadsVelAvgBig.data.definition,
		fidColumnName: 'gid',
		selected: {
			riskAssessmentRoads: {},
		},
	},
};

export const interferometryPointsSmall = {
	key: 'interferometry-points-small',
	type: 'vector',
	options: {
		renderingTechnique: 'canvas',
		pointAsMarker: true,
		features: [],
		style: styles.byKey.interferometryPointsVelAvgSmall.data.definition,
		fidColumnName: 'id',
	},
};

export default [
	riskAssessmentRoadsSmall,
	riskAssessmentRoadsBig,
	riskAssessmentZonesSmall,
	riskAssessmentZonesBig,
	interferometryZonesSmall,
	interferometryZonesBig,
	interferometryRoadsBig,
	interferometryRoadsSmall,
	interferometryPointsSmall,
	interferometryPointsBig,
];
